module.exports = __webpack_public_path__ + "static/media/arrow-down.c63b52d2.svg";